export default __webpack_public_path__ + "static/media/fondo_grecas.d5bd3e9e.png";